// Componentes del módulo de cajas/fondos
const IndexCajas = () => import('@/components/funds/Index-cajas.vue');
const DetalleCaja = () => import('@/components/funds/Detalle-caja.vue');
const CategoriasCajas = () => import('@/components/funds/Categorias-cajas.vue');
const ChequesCartera = () => import('@/components/funds/Cheques-cartera.vue');
const CuponesCartera = () => import('@/components/funds/Cupones-cartera.vue');
const ChequesPropios = () => import('@/components/funds/Cheques-propios.vue');
const CierreCajaModal = () => import('@/components/funds/Cierre-caja-modal.vue');

const funds = {
  path: '/cajas',
  redirect: { name: 'Cajas' },
  children: [
    {
      path: '',
      name: 'Cajas',
      component: IndexCajas,
      meta: { title: 'Cajas' },
    },
    {
      path: ':idCaja',
      name: 'Detalle de Caja',
      component: DetalleCaja,
      meta: { title: 'Detalle de Caja' },
    },
    {
      path: 'categorias',
      name: 'Categorias Cajas',
      component: CategoriasCajas,
      meta: { title: 'Categorías de Cajas' },
    },
    {
      path: 'cheques-terceros',
      name: 'Cheques de Terceros',
      component: ChequesCartera,
      meta: { title: 'Cheques de Terceros' },
    },
    {
      path: 'cupones-cartera',
      name: 'Cupones en cartera',
      component: CuponesCartera,
      meta: { title: 'Cupones de Tarjetas' },
    },
    {
      path: 'cheques-propios',
      name: 'Cheques Propios',
      component: ChequesPropios,
      meta: { title: 'Cheques Propios' },
    },
    {
      path: ':idCaja/cierre',
      name: 'Cierre de caja Modal',
      component: CierreCajaModal,
      meta: { title: 'Cierre de Caja' },
    },

  ],
};

export default funds;
